export enum ErrorCode {
    Error403 = "403",
    Error401 = "401",
    Error404 = "404",
    Error500 = "500",
}
